import { render, staticRenderFns } from "./ViewPiece.vue?vue&type=template&id=76170684&scoped=true"
import script from "./ViewPiece.vue?vue&type=script&lang=js"
export * from "./ViewPiece.vue?vue&type=script&lang=js"
import style0 from "./ViewPiece.vue?vue&type=style&index=0&id=76170684&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76170684",
  null
  
)

export default component.exports